import type { ReactNode } from 'react';

import {
    Button,
    Card,
    CardActions,
    CardBody,
    Description,
    Group,
    Heading,
    ProgressiveImage,
} from '@gitbook/spine-react';

import { PaidFeatureIndicator } from '../../../Components';
import imageDark from '../../../Components/Site/assets/site-section-intro-dark.raw.svg';
import imageLight from '../../../Components/Site/assets/site-section-intro-light.raw.svg';
import type { UseUpgradeSite } from '../../../state';
import { createDocumentationURL } from '../../../utils';

/**
 * Intro card for the site sections feature
 */
export function SiteStructureIntroCard(props: {
    upgrade: UseUpgradeSite | null;
    action: ReactNode;
    onDismiss?: () => void;
}) {
    const { upgrade, action, onDismiss } = props;
    return (
        <Card onDismiss={onDismiss}>
            <div className="grid grid-cols-1 lg:grid-cols-2">
                <CardBody>
                    <Group>
                        <Heading>Organize content with sections</Heading>
                        {upgrade && <PaidFeatureIndicator upgrade={upgrade} />}
                    </Group>
                    <Description>
                        Divide your site into sections to showcase every part of your product on a
                        single docs site. Combine sections with variants to create the perfect
                        structure for your content.
                    </Description>
                    <CardActions>
                        {action}
                        <Button
                            kind="blank"
                            target="_blank"
                            label="Learn more"
                            href={createDocumentationURL(
                                'published-documentation/site-structure-and-navigation/site-sections',
                                'docs'
                            )}
                        />
                    </CardActions>
                </CardBody>
                <CardBody>
                    <ProgressiveImage
                        src={{ light: imageLight, dark: imageDark }}
                        width="100%"
                        height="auto"
                        style={{ aspectRatio: '450 / 153' }}
                    />
                </CardBody>
            </div>
        </Card>
    );
}
